import {Injectable} from '@angular/core';
import {exhaustMap, tap, withLatestFrom} from 'rxjs/operators';

import {select, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {AppState, selectConfiguration, selectRouter} from '../core.state';

import {Config} from "../../services/config/config.service";
import {SecureWebsocketService} from "../../services/websockets/secure-websocket.service";
import {WebsocketService} from "../../services/websockets/websockets.service";
import {failMicrositeSessions, successMicrositeSessions} from '../coreAuth/coreAuth.actions';
import {selectMicrositeSessions} from '../coreAuth/coreAuth.selectors';
import {connectToPrivateChannel, setWebsocketEvent} from './coreWebsockets.actions';
import {EMPTY, of} from 'rxjs';
import {loadComments} from '../syndicates/syndicates.actions';

@Injectable()
export class MicrositeWebsocketsEffects {


  failMicrositeSessions = createEffect(() => {
    return this.actions$.pipe(
      ofType(failMicrositeSessions),
      withLatestFrom(this.store.pipe(select(selectMicrositeSessions))),
      tap(([propVal, micrositeSessions]) => {
        if (!micrositeSessions) return;
        this._websocketService.unSubscribeChannel('user-' + micrositeSessions.id);
      }))
  }, {dispatch: false});


  loadComments = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadComments),
      withLatestFrom(this.store.pipe(select(selectMicrositeSessions)), this.store.pipe(select(selectConfiguration))),
      tap(([propVal, micrositeSessions, config]) => {
        if (!propVal.params || !propVal.params.model_id) return;
        if (!config.commentarySettings) return;

        this._websocketServiceBalance.subscribeChannel('private-syndicate-' + propVal.params.model_id);
        this._websocketServiceBalance.bindAllChannelEvents('private-syndicate-' + propVal.params.model_id);
      }))
  }, {dispatch: false});


  connectToPrivateChannel = createEffect(() => {
    return this.actions$.pipe(
      ofType(connectToPrivateChannel),
      tap((propVal) => {
        this._websocketServiceBalance.connect(propVal.headers);
      }))
  }, {dispatch: false});


  micrositeAuthenticationRefresh = createEffect(() => {
    return this.actions$.pipe(
      ofType(successMicrositeSessions, failMicrositeSessions),
      exhaustMap((propVal) => {
        return of(setWebsocketEvent({
          event: 'MICROSITE_AUTHENTICATION_REFRESH',
          data: {}
        }));
      }))
  }, {dispatch: true});

  /* AUTH EVENTS */
  isMobile: boolean;
  successMicrositeSessions = createEffect(() => {
    return this.actions$.pipe(
      ofType(successMicrositeSessions),
      withLatestFrom(this.store.pipe(select(selectRouter))),
      exhaustMap(([propVal, routerState]) => {
        try {
          if (this._config.CONFIG.fallbackSecureWSnonCB) {
            this._websocketServiceBalance.connect({uid: propVal?.response?.ext_id});
          }
        } catch (e: any) {
          console.log("Error subscribing secure WS for a non CB microsite");
        }
        this._websocketService.subscribeChannel('user-' + propVal?.response?.id);
        this._websocketService.bindAllChannelEvents('user-' + propVal?.response?.id);

        if (propVal?.response?.has_offers &&
            (!routerState?.state?.queryParams?.utm_campaign ||
             routerState?.state?.queryParams?.utm_campaign !== 'Cash_out') &&
            !this.isMobile) {
          return of(setWebsocketEvent({
            event: 'USER_NEW_OFFER',
            data: null
          }));
        }

        return EMPTY;

      }))
  }, {dispatch: true});

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private _websocketService: WebsocketService,
    private _websocketServiceBalance: SecureWebsocketService,
    private _config: Config
  ) {
    this.isMobile = this._config.CONFIG.isMobile;
  }
}

